import { useState } from "react";
import { CanvasPanel, DesignTokens } from "melco-ui";
import styled from "styled-components";
import { DesignElementList } from "./DesignElementList";
import { DesignCanvas } from "../libraries/designs/DesignCanvas";
import { DesignElementDetailPanel } from "./DesignElementDetailPanel";
import { ServiceType } from "../../helper/serviceType";
import { EfsMelcoModelsDesign } from "melco-shared-logic";
import { useDesignElementList } from "../../hooks/designMappings/useDesignElementList";
import { useOutputElements } from "../../hooks/designMappings/useOutputElements";

const { spacings } = DesignTokens;

const DesignWrapper = styled.div`
  display: flex;
  margin: 0 -${spacings.xlarge}px;
`;

const DesignCanvasWrapper = styled.div`
  flex-grow: 1;
  margin: 0 ${spacings.xlarge}px;
`;

const LeftCanvasPanel = styled(CanvasPanel)`
  width: 300px;
`;

type DisplayManageDesignConfigurationProps = {
  design: EfsMelcoModelsDesign;
  inputFormatId: string;
  serviceType: ServiceType;
};

export const DisplayManageDesignConfiguration: React.FC<
  DisplayManageDesignConfigurationProps
> = ({ design, inputFormatId, serviceType }) => {
  const designElementList = useDesignElementList(design);

  const { mappableElements, groupIndex } = designElementList;

  useOutputElements(design, mappableElements);

  const [currentMappableElementIndex, setCurrentMappableElementIndex] =
    useState<number | undefined>(undefined);

  const currentDesignElement =
    currentMappableElementIndex != null
      ? mappableElements[currentMappableElementIndex]
      : undefined;

  return (
    <DesignWrapper>
      <LeftCanvasPanel elevation="right" data-cy-id="design-element-list-panel">
        <DesignElementList
          designElementList={designElementList}
          setCurrentDesignElementIndex={setCurrentMappableElementIndex}
          serviceType={serviceType}
        />
      </LeftCanvasPanel>

      <DesignCanvasWrapper>
        <DesignCanvas design={design} showStaticImage />
      </DesignCanvasWrapper>

      {currentMappableElementIndex != null && (
        <DesignElementDetailPanel
          design={design}
          formikPrefix={[
            "outputs.0.elements",
            currentMappableElementIndex,
          ].join(".")}
          inputFormatId={inputFormatId}
          currentDesignElement={currentDesignElement}
          groupIndex={groupIndex}
          setCurrentDesignElementIndex={setCurrentMappableElementIndex}
          serviceType={serviceType}
        />
      )}
    </DesignWrapper>
  );
};
